import * as globalActions from 'school-portal-actions'
import * as routerActions from 'react-router-redux'

export function signOut() {
  return function (dispatch) {
    dispatch(clearDetails())
    dispatch(routerActions.replace('/sign-in'))
  }
}

export function clearDetails() {
  return function (dispatch) {
    dispatch(globalActions.setAuthenticated({ token: null }))
    dispatch(globalActions.setIsAdmin(false))
    dispatch(globalActions.setCurrentSchoolId(null))
    dispatch(globalActions.clearSchool())
  }
}
